// Phase Gate Templates — phase label/order constants extracted from
// SettingsPage.tsx so they can be imported by tests without dragging in the
// page's React tree (and its 100+ transitive imports). These are the keys
// produced by `apps/api/src/db/seeds/phaseGateTemplates.ts`, NOT the SDLC
// enum values used elsewhere — `phase_2_5`, not `phase_2_5_ux_design`.

export const PHASE_LABELS: Record<string, string> = {
  phase_1:   'Phase 1: Requirements',
  phase_2:   'Phase 2: Architecture',
  phase_2_5: 'Phase 2.5: UX Design',
  phase_3:   'Phase 3: Sprint Planning',
  phase_4:   'Phase 4: Development',
  phase_5:   'Phase 5: Code Review',
  phase_6:   'Phase 6: QA/Testing',
  phase_7:   'Phase 7: Deployment',
};

export const PHASE_ORDER = [
  'phase_1',
  'phase_2',
  'phase_2_5',
  'phase_3',
  'phase_4',
  'phase_5',
  'phase_6',
  'phase_7',
  'other',
];
